import { useState } from 'react';
import styled from 'styled-components';
import { useGetPtoVolumesSummaryQuery } from '@shared/api';
import { LinkButton } from './systemsUi';

const Box = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(3)};
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

const List = styled.ul`
  margin: ${({ theme }) => theme.spacing(1)} 0 0;
  padding-left: ${({ theme }) => theme.spacing(5)};
`;

/** Сколько систем перечня показывать в строке до «ещё». */
const SHOWN = 12;

interface Props {
  revisionId: string;
}

/** Перечень систем комплекта (таблицы «Характеристика систем», «Основные
 *  показатели систем» — `metadata.systems` ревизии) с листом, откуда он взят:
 *  по нему разбор проверяет коды систем строк. */
export function SystemsRegistry({ revisionId }: Props) {
  const { data } = useGetPtoVolumesSummaryQuery(revisionId, { skip: !revisionId });
  const [open, setOpen] = useState(false);
  const entries = data?.registry?.registry ?? [];
  if (!data?.systems || entries.length === 0) {
    return data?.systems ? (
      <Box>Перечень систем комплекта в РД не найден — коды систем строк не сверены.</Box>
    ) : null;
  }
  const pages = [...new Set(entries.map((e) => e.page).filter((p) => typeof p === 'number'))];
  const labels = [...new Set(entries.map((e) => e.label).filter(Boolean))];
  const head = labels.slice(0, SHOWN).join(', ');
  return (
    <Box>
      Перечень систем комплекта{pages.length ? ` (стр. ${pages.join(', ')})` : ''}: {head}
      {labels.length > SHOWN && ` и ещё ${labels.length - SHOWN}`}.{' '}
      <LinkButton type="button" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
        {open ? 'Скрыть перечень' : 'Перечень систем'}
      </LinkButton>
      {open && (
        <List>
          {entries.map((e, i) => (
            <li key={`${e.label}-${i}`}>
              {e.label}
              {e.name ? ` — ${e.name}` : ''}
              {e.kind ? `; ${e.kind}` : ''}
              {e.rooms ? `; ${e.rooms}` : ''}
              {typeof e.page === 'number' ? ` (стр. ${e.page})` : ''}
            </li>
          ))}
        </List>
      )}
    </Box>
  );
}
